module.exports = __webpack_public_path__ + "img/insight-phone.9844054a.png";